import edap from '@homeaway/edap-wrapper';

export const EVENT_TYPES = {
    DISMISSED: 'virtual_agent.hidden',
    ON_ERROR: 'virtual_agent.failed',
    PRESENTED: 'virtual_agent.presented',
    SELECTED: 'virtual_agent.selected',
    SUCCEEDED: 'virtual_agent.succeeded',
};
const triggerEdap = (name, data, daysToCheckin) => {
    if (daysToCheckin) {
        data.days_to_checkin = daysToCheckin;
    }
    edap().push({
        name,
        data,
    });
};
export const VaEdapEvents = {
    onError: (
        {actionLocationEDAP, daysToCheckin, skillType},
        reservationUuid,
        error
    ) => {
        const eventData = {
            action_location: actionLocationEDAP || 'trip_details',
            skill_type: skillType,
            reservation_id: reservationUuid,
            error,
        };
        triggerEdap(EVENT_TYPES.ON_ERROR, eventData, daysToCheckin);
    },
    onVaInitDone: (
        {actionLocationEDAP, daysToCheckin, phaseOfStay, skillType},
        isHelpTextShown
    ) => {
        const eventData = {
            skill_type: skillType,
        };
        if (actionLocationEDAP) {
            eventData.action_location = actionLocationEDAP;
        } else if (isHelpTextShown) {
            eventData.phase_of_stay = phaseOfStay;
            eventData.action_location = 'trip_details_help_with_overlay';
        } else {
            eventData.action_location = 'trip_details_help';
        }
        triggerEdap(EVENT_TYPES.PRESENTED, eventData, daysToCheckin);
    },
    onDismissHelpText: ({daysToCheckin, skillType}) => {
        const eventData = {
            skill_type: skillType,
            action_location: 'trip_details_overlay',
        };
        triggerEdap(EVENT_TYPES.DISMISSED, eventData, daysToCheckin);
    },
    onVaOpenClick: (
        {actionLocationEDAP, daysToCheckin, skillType},
        {source}
    ) => {
        if (!actionLocationEDAP) {
            actionLocationEDAP =
                source === 'overlay'
                    ? 'trip_details_overlay'
                    : 'trip_details_help';
        }
        const eventData = {
            skill_type: skillType,
            action_location: actionLocationEDAP,
        };
        triggerEdap(EVENT_TYPES.SELECTED, eventData, daysToCheckin);
    },
    onChatFrameOpenSuccess: (
        {actionLocationEDAP, daysToCheckin, skillType},
        reservationUuid
    ) => {
        const eventData = {
            skill_type: skillType,
            action_location: actionLocationEDAP || 'trip_details',
            reservation_id: reservationUuid,
        };
        triggerEdap(EVENT_TYPES.SUCCEEDED, eventData, daysToCheckin);
    },
};
